module.exports = __webpack_public_path__ + "static/media/aquarider-10222.f7112d7d.png";